import axios from "axios";


import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'

export default {
    namespaced: true,
    state: {
        ordersList : [],

    },

    getters: {
    },

    mutations: {
        setOrderList (state, ordersList) {
            state.ordersList  = ordersList

        },


    },

    actions: {
        /* eslint-disable no-console */
        fetchOrdersList({commit}) {

            return new Promise((resolve,reject) => {
                // make the call
                // call setProducts mutation
                //    api_master_data.getPathologists(pathologists => {
                //     commit('setPathologists', pathologists)
                //     resolve()
                // })


                axios.post(`${getBaseURLforBackEnd()}/api/orderlablist`,getConfigAxios())
                    .then((res)=>{
                        commit('setOrderList', res.data)
                        resolve(res.data)
                    })
                    .catch(err=>{
                        reject(err)
                    })

            })
        }

    }
}